import { Button, Stack, Typography } from '@mui/material';
import { useOktaAuth } from '@okta/okta-react';
import { useTranslation } from 'react-i18next';
import Backend from '../backend/Backend';
import SFDCAppScope from '../sfdc/SFDCAppScope';
import { sfdcOAuthCallbackUrl } from '../sfdc/pkce';
import Util from '../Util';
import '../wizard/DataSource.scss';

const SFConnector = (props) => {
    const { authState, oktaAuth } = useOktaAuth();

    const initiateReconnect = (config_id?: string) => {
        const win = Util.popupWindow(`/sfdc/source?appScope=${SFDCAppScope.default}`, 'Service Insights - Reconnect');
        (window as any).setLoginResponse = function (
            auth_code: string,
            domain: string,
            _instance_url?: string,
            code_verifier?: string,
        ) {
            (window as any).setLoginResponse = () => {};
            win!.close();
            processReconnect(auth_code, domain, config_id, code_verifier);
        };
    };

    async function processReconnect(
        auth_code: string,
        domain: string,
        config_id?: string,
        code_verifier?: string,
    ) {
        props.progress(true);
        const resp = await Backend.login(
            config_id,
            auth_code,
            domain,
            'Source',
            oktaAuth,
            code_verifier,
            sfdcOAuthCallbackUrl('source'),
        );
        const credentials = {
            access_token: resp.data.access_token,
            refresh_token: resp.data.refresh_token,
            login_url: domain,
            instance_url: resp.data.instance_url,
            user_name: resp.data.username,
        };

        props.progress(false);
        props.callback(credentials);
        // setToastMessage("Reconnected successfully");
    }

    const { t } = useTranslation();

    return (
        <Stack direction="column" spacing={2}>
            {!props.loggedIn ? (
                <>
                    <div> {t('wizard.data-source.transfer-data-description')}</div>

                    <Button onClick={() => initiateReconnect(props.config_id)} className="RefreshBtn">
                        {t('wizard.data-source.sf-login-button')}
                    </Button>
                </>
            ) : (
                <Stack direction="row">
                    <Typography>{t('wizard.data-source.transfer-data-logged-desc')}</Typography>
                    <Button
                        variant="text"
                        sx={{ marginLeft: '16px', padding: 0, fontSize: '13px' }}
                        onClick={() => initiateReconnect(props.config_id)}
                        data-testid="data-source-sf-login-btn"
                    >
                        {t('wizard.data-source.sf-logged-in-button')}
                    </Button>
                </Stack>
            )}
        </Stack>
    );
};

export default SFConnector;
